<template>
	<div
		class="p-d-flex p-flex-column p-flex-md-row p-text-left p-justify-center p-grid"
	>
		<Accordion class="p-col-12" :multple="false" :activeIndex="active">
			<AccordionTab>
				<template #header>
					<div
						class="p-d-flex p-justify-between p-ai-center"
						style="width: 100%"
					>
						<p class="p-my-0">
							{{
								parentData.firstName && parentData.lastName != null
									? parentData.firstName + " " + parentData.lastName
									: parentData.firstName != null
									? parentData.firstName
									: "Parent #" + (parentIndex + 1)
							}}
						</p>

						<div>
							<Button
								icon="pi pi-times"
								class="p-button-text p-p-0"
								@click="removeBlock($event)"
							/>
						</div>
					</div>
				</template>

				<div class="p-fluid p-formgrid">
					<div class="name p-grid p-pt-2">
						<div class="p-col-12 p-lg-6 p-field">
							<label class="p-text-bold" for="firstName">First Name: *</label>

							<InputText
								id="firstName"
								type="text"
								v-model="parentData.firstName"
								placeholder="First Name"
							/>

							<small
								v-if="v$.parentData.firstName.$invalid && submitted"
								class="p-error"
							>
								{{
									v$.parentData.firstName.required.$message.replace(
										"Value",
										"First Name"
									)
								}}
							</small>
						</div>

						<div class="p-col-12 p-lg-6 p-field">
							<label class="p-text-bold" for="lastName">Last Name: *</label>

							<InputText
								id="lastName"
								type="text"
								v-model="parentData.lastName"
								placeholder="Last Name"
							/>

							<small
								v-if="v$.parentData.lastName.$invalid && submitted"
								class="p-error"
							>
								{{
									v$.parentData.lastName.required.$message.replace(
										"Value",
										"Last Name"
									)
								}}
							</small>
						</div>

						<div class="p-col-12 p-lg-6 p-field">
							<label class="p-text-bold" for="phone"> Phone Number: * </label>

							<InputText
								id="phone"
								v-model="parentData.phone"
								placeholder="Phone Number"
								v-mask="'(###) ###-####'"
								inputmode="tel"
							/>

							<small
								v-if="v$.parentData.phone.$invalid && submitted"
								class="p-error"
							>
								{{
									v$.parentData.phone.required.$message.replace(
										"Value",
										"Phone Number"
									)
								}}
							</small>
						</div>

						<div class="p-col-12 p-lg-6 p-field">
							<label class="p-text-bold" for="phone2">
								2nd Phone Number:
							</label>

							<InputText
								id="phone2"
								v-model="parentData.phone2"
								placeholder="2nd Phone Number"
								v-mask="'(###) ###-####'"
								inputmode="tel"
							/>
						</div>

						<div class="p-col-12 p-field">
							<label class="p-text-bold" for="relationship">
								Relationship:
							</label>

							<InputText
								id="relationship"
								type="text"
								v-model="parentData.relationship"
								placeholder="Relationship (optional)"
							/>
						</div>
					</div>
				</div>
			</AccordionTab>
		</Accordion>
	</div>
</template>

<script>
import { useFormDataStore } from "../../store/formData.js";
import { useVuelidate } from "@vuelidate/core";
import { required, minLength } from "@vuelidate/validators";

export default {
	name: "ParentInfo",
	data() {
		return {
			active: 0,
			submitted: false,
		};
	},
	setup() {
		const store = useFormDataStore();

		return {
			v$: useVuelidate(),
			store,
		};
	},
	validations() {
		return {
			parentData: {
				firstName: { required },
				lastName: { required },
				phone: { required, minLength: minLength(14) },
			},
		};
	},
	props: {
		parentData: Object,
		parentIndex: Number,
		validateForm: Number,
		validateAllForms: Function,
	},
	watch: {
		async validateForm() {
			const isFormValid = await this.v$.$validate();
			this.submitted = true;

			this.validateAllForms(isFormValid, this.parentIndex, "parent");
		},
	},
	methods: {
		removeBlock(event) {
			event.stopPropagation();

			this.$emit("removeBlock", this.parentIndex);
		},
	},
};
</script>

<style lang="scss" scoped></style>
